import React, { FC } from 'react'

import { SettingsView } from '@lib/views'

import AccountSettingsView from '@views/settings/AccountSettingsView'
import ContentSettingsView from '@views/settings/ContentSettingsView'
import PrivacySettingsView from '@views/settings/PrivacySettingsView'
import { useSession } from '@context/sessions'
import NotFoundPage from './NotFoundPage'

interface SettingsPageProps {
  view?: SettingsView
}

const SettingsPage: FC<SettingsPageProps> = ({
  view = SettingsView.AccountSettings,
}) => {
  const session = useSession()

  return (
    <>
      {session ? (
        <div>
          {view === SettingsView.AccountSettings && <AccountSettingsView />}
          {view === SettingsView.ContentSettings && <ContentSettingsView />}
          {view === SettingsView.PrivacySettings && <PrivacySettingsView />}
        </div>
      ) : (
        <NotFoundPage />
      )}
    </>
  )
}

export default SettingsPage
